@let isDirty = $isDirty();
@let isInvalid = $isInvalid();
<h2 mat-dialog-title>
  {{ dialogData.title }}
  @if (isDirty) {
    <div>
      <span style="color: #f44336; font-size: 0.6em; margin-left: 8px">(Unsaved Changes)</span>
    </div>
  }
</h2>
<mat-dialog-content>
  <div style="margin-top: 10px">
    <ng-container #formContainer></ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-button
    (click)="handleCancel()"
    cdkFocusInitial
  >
    {{ dialogData.closeLabel }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="handleSave()"
    [disabled]="isInvalid || !isDirty"
  >
    {{ dialogData.submitLabel }}
  </button>
</mat-dialog-actions>
